import React from 'react'
import { FormattedMessage as Lang } from 'react-intl'

export default {
  'error.not.found.required.field': <Lang id="constants.errors.requiredField" />,
}